export const environment = {
  production: true,
  environment_name: "somerset",
  environment_title: "Somerset Mall",
  environment_url: "https://www.somersetmall.co.za/",
  environment: "prod",
  api_base_url: "https://api.hyprop.co.za/",
  api_auth_url: "https://auth-api.hyprop.co.za/",
  cdn_url: "https://cdn.hyprop.co.za/",
  mall_id: "45626cb4-960e-45cc-8f3a-a8fab4d0bcca",
  addressLat: -34.08103595353481,
  addressLng: 18.823019984657062,
  recaptcha_key: "6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL",
  social_google_key:
    "150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com",
  social_facebook_key: "253233436432992",
  sso_url: "https://sso.hyprop.co.za",
  google_verification: "eCZR7-f_EL9aQIUXy4b141aAWPB29phYf_TllpIIHek",
  street_address: "Centenary Drive, Intersection of N2 & R44, Somerset West",
  address_locality: "Somerset West",
  postal_code: "7130",
  address_country: "ZA",
  contact_form_uuid: "ebhv3gwj",
  google_api_key: "AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8",
};
